// Les pages qui lisent VOLONTAIREMENT les APIs avec la clé anon, avant toute
// connexion : réservation en ligne, liens de paiement, confirmations,
// inscription. Hors d'elles, une requête anon alors que l'app ne se croit pas
// connectée est un écran privé en train de se démonter (déconnexion, session
// perdue déjà annoncée) : la porte la retient en silence (voir
// `sessionGuardedFetch.ts`, `sessionAbsentResponse`).
//
// ⛔ Ce module n'importe RIEN : `client.ts` l'importe, et tout import ici
// risquerait le cycle que l'enregistrement différé du renouvellement existe
// pour éviter.
//
// ⚠️ Une page publique ajoutée à `App.tsx` doit être inscrite ici, sinon ses
// visiteurs anonymes seraient bloqués. `anonymousDataRoutes.test.ts` compare
// cette liste aux routes de `App.tsx` et rougit en cas d'oubli.

const EXACT = ['/', '/email-confirmed', '/desabonnement', '/subscription-success', '/client/book'];

const PREFIXES = ['/auth/', '/invite/', '/pay/', '/confirmer-rdv/', '/en/confirmer-rdv/', '/book/'];

export function isAnonymousDataPath(pathname: string): boolean {
  // Même tolérance que React Router : casse ignorée, barre oblique finale
  // acceptée. Sans elle, `/Book/salon-1` afficherait la réservation mais ses
  // lectures seraient retenues en silence.
  const chemin = pathname.toLowerCase().replace(/\/+$/, '') || '/';
  return EXACT.includes(chemin) || PREFIXES.some((prefixe) => chemin.startsWith(prefixe));
}
